/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Page } from '../../models/page';

export interface ApiMasterPageGetPageBySubMenuIdGet$Params {
  id?: number;
}

export function apiMasterPageGetPageBySubMenuIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterPageGetPageBySubMenuIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Page>> {
  const rb = new RequestBuilder(rootUrl, apiMasterPageGetPageBySubMenuIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Page>;
    })
  );
}

apiMasterPageGetPageBySubMenuIdGet.PATH = '/api/Master/Page/GetPageBySubMenuId';
